export function convertToPlain(html: string) {
  const tempDivElement = document.createElement('div');
  tempDivElement.innerHTML = html;

  return tempDivElement.textContent || tempDivElement.innerText || '';
}
